// The admin console's one-time code (#handoff=…) first: out of the address bar
// and into memory before any other module runs, so no error report, log line,
// stored value or later address can carry it.
import "./handoffFirst";
import { errorReporter } from "./lib/errorReporter";
import { startHandoff } from "./lib/handoff";
import { forgetLegacyCredentials } from "./lib/session";

// Error monitoring first, before anything else can throw.
errorReporter.init();
forgetLegacyCredentials();
// The code is spent while the descriptor loads; the gate waits for it.
void startHandoff();

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { loadChains } from "./lib/chains";
import { loadRuntimeConfig } from "./lib/runtimeConfig";
import { restoreWalletSession } from "./lib/wallet";
import { PROVIDER_FUTURE, ROUTER_FUTURE, routes } from "./routes";
import "./styles.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container #root not found");
}
const root = createRoot(container);

root.render(
  <StrictMode>
    <div className="boot-screen" role="status" aria-label="Loading">
      <span className="spinner" />
    </div>
  </StrictMode>,
);

// Boot: the handoff fragment → error reporter → the handoff's exchange → the
// descriptor and `/chains.json` (neither rejects, so an unreachable gateway
// degrades instead of blocking; the file names the explorers before any link
// is drawn) → a WalletConnect pairing this browser still holds (never prompts;
// waited for a few seconds at most) → router. The gate checks the session.
void Promise.all([loadRuntimeConfig(), loadChains()]).then(async () => {
  await restoreWalletSession().catch(() => "none");
  const router = createBrowserRouter(routes, { future: ROUTER_FUTURE });
  root.render(
    <StrictMode>
      <ErrorBoundary>
        <RouterProvider router={router} future={PROVIDER_FUTURE} />
      </ErrorBoundary>
    </StrictMode>,
  );
});
